import React, { useState, useEffect } from "react";
import moment from "moment";
import API from '../Services/Product'
const ViewBothProduct = ({ fetchData }) => {
    const [showSingleModal, setShowSingleModal] = useState(false);
    const [showComboModal, setShowComboModal] = useState(false);
    const [subProductType, setSubProductType] = useState([]);

    useEffect(() => {
        if (fetchData) {
            // console.log('fetchData...', fetchData);

            if (fetchData.is_combo === true) {
                setShowComboModal(true);
                setShowSingleModal(false);
                // console.log('fetchData?.id', fetchData?.id);

                const fetchSubProduct = async () => {
                    try {
                        const response = await API.getSubProduct(fetchData?.id);
                        setSubProductType(response?.data?.data?.rows || []);
                        // console.log('response', response?.data?.data?.rows || []);

                    } catch (error) {
                        console.error('Error fetching sub product:', error);
                    }
                };
                fetchSubProduct();
            } else {
                setShowSingleModal(true);
                setShowComboModal(false);
            }
        }
    }, [fetchData]);
    return (
        <>
            <div className="container mt-4">

                {showSingleModal && (
                    <div className="modal show d-block" style={{ backgroundColor: "#f2edf3" }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-lg" >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Single Product Type Details</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={() => setShowSingleModal(false)}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <table class="table table-bordered border-secondary">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Center Name</th>
                                                <th>Sales Tab Name</th>
                                                <th>Product Type Name</th>
                                            </tr>
                                            <tr>
                                                <td>{fetchData.name}</td>
                                                <td>{fetchData.location_name}</td>
                                                <td>{fetchData.sale_tab_name}</td>
                                                <td>{fetchData.product_type_name}</td>
                                            </tr>
                                            <tr>
                                                <th>Amount</th>
                                                <th>Price Type</th>
                                                <th>SkyCoins (SPCL)</th>
                                                <th>Tax Rate Type</th>
                                            </tr>
                                            <tr>
                                                <td>{fetchData.amount}</td>
                                                <td>{fetchData.price_type}</td>
                                                <td>{fetchData?.special_price}</td>
                                                <td>{fetchData.tax_rate_type}</td>
                                            </tr>
                                            <tr>
                                                <th>Machine Name</th>
                                                <th>Time</th>
                                                <th>Combo / Is Recipe / Status / Expose Api</th>
                                                {/* <th>Combo / Track Inventory / Is Recipe / Status</th> */}
                                                <th>Display Order</th>

                                            </tr>
                                            <tr>
                                                <td>{fetchData.machine_name}</td>
                                                <td>{fetchData.time}</td>
                                                <td>{fetchData.is_combo ? "Yes" : "No"} / {fetchData.is_recipe ? "Yes" : "No"}  / {fetchData.is_active ? "Active" : "De-Activated"} / {fetchData?.expose_api ? "True" : "False"}</td>
                                                {/* <td>{fetchData.is_combo ? "True" : "False"} / {fetchData.track_inventory ? "True" : "False"} / {fetchData.is_recipe ? "True" : "False"} / {fetchData.is_active ? "True" : "False"}</td> */}
                                                <td>{fetchData.display_order}</td>
                                            </tr>
                                            <tr>
                                                <th>MRP</th>
                                                <th>Created Date</th>
                                                <th colSpan={3}>Description</th>
                                            </tr>
                                            <tr>
                                                <td>{fetchData.mrp}</td>
                                                <td>{moment(fetchData.createdAt).format("DD-MM-YYYY")}</td>
                                                <td colSpan={3}>{fetchData.description}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showComboModal && (
                    <div className="modal  show d-block" style={{ backgroundColor: "#f2edf3" }} tabIndex="-1" role="dialog" aria-modal="true">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Combo Product Type Details</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={() => setShowComboModal(false)}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <table class="table table-bordered border-secondary">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Center Name</th>
                                                <th>Sales Tab Name</th>
                                                <th>Product Type Name</th>
                                            </tr>
                                            <tr>
                                                <td>{fetchData.name}</td>
                                                <td>{fetchData.location_name}</td>
                                                <td>{fetchData.sale_tab_name}</td>
                                                <td>{fetchData.product_type_name}</td>
                                            </tr>

                                            <tr>

                                                <th>Amount / Special Price</th>
                                                <th>Price Type</th>
                                                <th>Tax Rate Type</th>
                                                <th>Machine Name</th>
                                            </tr>
                                            <tr>
                                                <td>{fetchData.amount} / {fetchData.special_price}</td>
                                                <td>{fetchData.price_type}</td>
                                                <td>{fetchData.tax_rate_type}</td>
                                                <td>{fetchData.machine_name}</td>
                                            </tr>
                                            <tr>
                                                <th>Time</th>
                                                <th>Combo / Track Inventory / Is Recipe / Status</th>
                                                <th>Display Order</th>
                                                <th>Created Date</th>
                                            </tr>
                                            <tr>
                                                <td>{fetchData.time}</td>
                                                <td>{fetchData.is_combo ? "Yes" : "No"} / {fetchData.track_inventory ? "Yes" : "No"} / {fetchData.is_recipe ? "Yes" : "No"} / {fetchData.is_active ? "Active" : "De-Activated"}</td>
                                                <td>{fetchData.display_order}</td>
                                                <td>{moment(fetchData.createdAt).format("DD-MM-YYYY")}</td>
                                            </tr>
                                            <tr>
                                                <th colSpan={4}>Description</th>
                                            </tr>
                                            <tr>
                                                <td colSpan={4}>{fetchData.description}</td>
                                            </tr>
                                        </thead>
                                    </table>

                                    <div className="card-header my-4">
                                        <h4>Sub Product List</h4></div>
                                    <table className="table table-bordered border-secondary">
                                        <thead>
                                            <tr>
                                                <th>Product Name</th>
                                                <th>Time</th>
                                                <th>Quantity</th>
                                                <th>Discounted Price</th>
                                                <th>Discounted Price(SPCL)</th>
                                                <th>Status</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {subProductType.length > 0 ? (
                                                subProductType.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.product_name}</td>
                                                        <td>{item.time}</td>
                                                        <td>{item.quantity}</td>
                                                        <td>{item?.offered_price}</td>
                                                        <td>{item?.special_price}</td>
                                                        <td>{item.is_active ? "Active" : "De-Activated"}</td>
                                                        <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>

                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No sub-products available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ViewBothProduct;
